import axios from "axios";
import { EncryptToBase64WithPassword, DecryptFromBase64WithPassword } from "../cript/cript";
import { BASE_URL, CREATE_ORDER, VALIDATE_PAYMENT } from "../endpoints/endpoints";

export async function PaymentCardCredit(data, onError, onStatus) {

    let endereco = data.endereco
    let cartao = data.cartao
    let usuario = data.usuario
    let product = data.product
    let productSplitRules = data.product.split_rules

    let url = BASE_URL + CREATE_ORDER;

    let validateCardCredit = cartao.validade_cartao.split("/")
    let exp_month = parseInt(validateCardCredit.length > 0 ? validateCardCredit[0] : '0');
    let exp_year = parseInt(validateCardCredit.length > 1 ? validateCardCredit[1] : '0');

    const isBR = endereco.country === 'BR';
    usuario.country_code_phone = _setCountryCode(usuario.phone, isBR).replace("+", "");
    usuario.area_code_phone = _setAreaCode(usuario.phone, isBR);
    usuario.phone_number = _setPhoneNumber(usuario.phone, isBR);

    cartao.numero_cartao = cartao.numero_cartao.replace(/\D/g, '');


    let postData = {
        "product": {
            "id": product.id,
            "amount": product.amount,
            "description": product.description,
            "name": product.name,
        },
        "customer": {
            "name": usuario.nome,
            "email": usuario.email,
            "cpf": usuario.document,
            "phone": usuario.phone,
            "area_code_phone": usuario.area_code_phone,
            "country_code_phone": usuario.country_code_phone,
            "phone_number": usuario.phone_number
        },
        "address": {
            "line_1": `${endereco.rua}, ${endereco.bairro}, ${endereco.numero}`,
            "zip_code": endereco.cep,
            "city": endereco.cidade,
            "province": endereco.estado,
            "country": endereco.country
        },
        "items": [
            {
                "amount": product.amount,
                "description": product.description,
                "quantity": product.quantity,
                "code": product.code,
            },
        ],
        "payments": [
            {
                "split_rules": productSplitRules,
                "payment_method": "credit_card",
                "credit_card": {
                    "number": cartao.numero_cartao,
                    "holder_name": cartao.nome_cartao,
                    "exp_month": exp_month,
                    "exp_year": exp_year,
                    "cvv": cartao.cvv,
                    "installments": cartao.installments,
                    "totalValue": cartao.totalValue,
                }
            }
        ]
    };

    const dataEncript = EncryptToBase64WithPassword(postData)
    const dataData = { "data": dataEncript }

    await axios.post(url, dataData).then((response) => {
        if (!response) {
            onError();
            return;
        }

        const decode64 = DecryptFromBase64WithPassword(response.data);

        const data = decode64.data;

        const status = data.status

        onStatus(status);
    })
        .catch((error) => {
            console.error('Error:', error);

            if (!error.response || !error.response.data) {
                onError('Erro ao criar pedido')
                return
            } else {
                const message = error.response.data.message;
                onError(message);
            }
        });
}

export async function CreateOrderPix(data, onError, onStatus) {
    let endereco = data.endereco
    let cartao = data.cartao
    let usuario = data.usuario
    let product = data.product
    let productSplitRules = data.product.split_rules

    let url = BASE_URL + CREATE_ORDER;

    const isBR = endereco.country === 'BR';
    usuario.country_code_phone = _setCountryCode(usuario.phone, isBR).replace("+", "");
    usuario.area_code_phone = _setAreaCode(usuario.phone, isBR);
    usuario.phone_number = _setPhoneNumber(usuario.phone, isBR);

    let postData = {
        "product": {
            "id": product.id,
            "amount": product.amount,
            "description": product.description,
            "name": product.name,
        },
        "customer": {
            "name": usuario.nome,
            "email": usuario.email,
            "cpf": usuario.document,
            "phone": usuario.phone,
            "area_code_phone": usuario.area_code_phone,
            "country_code_phone": usuario.country_code_phone,
            "phone_number": usuario.phone_number
        },
        "address": {
            "line_1": `${endereco.rua}, ${endereco.bairro}, ${endereco.numero}`,
            "zip_code": endereco.cep,
            "city": endereco.cidade,
            "province": endereco.estado,
            "country": endereco.country
        },
        "items": [
            {
                "amount": product.amount,
                "description": product.description,
                "quantity": product.quantity,
                "code": product.code,
            },
        ],
        "payments": [
            {
                "split_rules": productSplitRules,
                "payment_method": "pix",
                "pix": {
                    "expires_in": 7200,
                    "amount": product.amount,
                    "name": product.description,
                    "value": product.quantity.toString(),
                }
            }
        ]
    };

    const dataEncript = EncryptToBase64WithPassword(postData)
    const dataData = { "data": dataEncript }


    await axios.post(url, dataData).then((response) => {
        if (!response) {
            onError();
            return;
        }

        const decode64 = DecryptFromBase64WithPassword(response.data).data;

        const status = decode64.status
        const closed = decode64.closed
        const orderId = decode64.id
        const charges = decode64.charges
        const pixCode = charges.length > 0 ? charges[0].last_transaction.qr_code : '';

        onStatus(status, closed, orderId, pixCode);
    })
        .catch((error) => {
            const decode64 = DecryptFromBase64WithPassword(error.response.data);
            console.error('Error:', error);

            if (!error.response || !error.response.data) {
                onError('Erro ao criar pedido')
                return
            } else {
                const message = error.response.data.message;
                onError(message);
            }
        });
}

export async function ValidatePix(orderId, onError, onStatus) {

    let url = BASE_URL + VALIDATE_PAYMENT + "?id=" + orderId;


    await axios.get(url).then((response) => {
        if (!response) {
            onError();
            return;
        }

        const decode64 = DecryptFromBase64WithPassword(response.data).data;

        const status = decode64.status
        const closed = decode64.closed
        const orderId = decode64.id
        const charges = decode64.charges
        const pixCode = charges.length > 0 ? charges[0].last_transaction.qr_code : '';

        onStatus(status, closed, orderId, pixCode);
    })
        .catch((error) => {
            console.error('Error:', error);

            if (!error.response || !error.response.data) {
                onError('Erro ao criar pedido')
                return
            } else {
                const message = error.response.data.message;
                onError(message);
            }
        });
}

//04886565

function _setCountryCode(phone, IsBR = true) {
    phone = phone.replace(" ", "");
    let countryCodeE = '';

    const index = phone.indexOf(")")

    if (index > 0) {
        countryCodeE = phone.substring(0, IsBR ? index - 3 : index - 4);
    }

    return countryCodeE;
}

function _setAreaCode(phone, IsBR = true) {
    let phoneAreaCode = '';

    const index = phone.indexOf("(");

    if (index > 0) {
        phoneAreaCode = phone.substring(index + 1, IsBR ? index + 3 : index + 4);
    }

    return phoneAreaCode;
}

function _setPhoneNumber(phone, IsBR = true) {
    let phoneNumber = '';

    phone = phone.replace(" ", "");
    phone = phone.replace("-", "");
    phone = phone.replace("  ", "");

    const index = phone.indexOf(")");

    if (index > 0) {
        phoneNumber = phone.substring(index + 1, phone.length);
    }

    phoneNumber = phoneNumber.replace(" ", "");
    phone = phone.replace("  ", "");
    phone = phone.replace("_", "");

    return phoneNumber;
}